const pino = require('pino')

const datadogAppId = process.env.DATADOG_APP_ID || 'unknown'

const logger = pino({
  level: process.env.LOG_LEVEL || 'info',
  messageKey: 'message',
  formatters: {
    level: label => ({ level: label.toUpperCase() })
  },
  timestamp: pino.stdTimeFunctions.isoTime,
  base: {
    ddsource: 'nuxt',
    app_id: datadogAppId
  },
  // Redact sensitive data
  redact: {
    paths: [
      'req.headers.authorization',
      'req.headers.cookie',
      'res.headers.setCookie',
      'error.config.headers.cookie',
      'req.body',
      'res.body'
    ],
    censor: '***REDACTED***'
  }
})

module.exports = logger
